// hooks/useZocdocBooking.ts
"use client";

import { useCallback } from 'react';

// Add type declarations for window.ZocDoc
declare global {
  interface Window {
    ZocDoc?: {
      plugin?: {
        init?: () => void;
        embed?: () => void;
      };
    };
  }
}

export const useZocdocBooking = () => {
  const openBooking = useCallback(() => {
    // Check if we're in development
    const hostname = window.location.hostname;
    const isDev = hostname === 'localhost' || hostname === '127.0.0.1' || hostname.includes('localhost');

    if (isDev) {
      // Development: Always use direct link to YOUR Zocdoc page
      window.open('https://app.nexhealth.com/appt/smile4me_dental_care?lid=77847&tracking_key=b2d71902-5ce0-43c1-bc95-24cdee27de9a', '_blank', 'noopener,noreferrer');
    } else {
      // Production: Try to use Zocdoc widget, fallback to YOUR Zocdoc page
      if (window.ZocDoc && window.ZocDoc.plugin) {
        // Trigger the Zocdoc widget
        const event = new CustomEvent('zocdoc-open', {
          detail: { practiceId: '86451' }
        });
        window.dispatchEvent(event);
      } else {
        // Fallback to YOUR direct Zocdoc link
        window.open('https://app.nexhealth.com/appt/smile4me_dental_care?lid=77847&tracking_key=b2d71902-5ce0-43c1-bc95-24cdee27de9a', '_blank', 'noopener,noreferrer');
      }
    }
  }, []);

  return { openBooking };
};